import React, { FC } from 'react';
import { IMRBeaconSVGProps } from './icons.types';

const CheckmarkStarted: FC<IMRBeaconSVGProps> = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <circle cx="12" cy="12" r="11.5" fill="white" stroke="#248647" />
      <path
        d="M7.5 13.0741L10.4934 15.875L15.625 9"
        stroke="#248647"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CheckmarkStarted;
